import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import st from "lib/utils/index";
import { AffiliateRepository } from "lib/repositories/index";
import { replaceCompanyRoute } from "modules/app/actions";
import { createResourceInstance } from "modules/utils/index";
import { createFiltersInstance } from "modules/utils/createFilteredItemsInstance";

export const INITIALIZE_VIEW = "affiliate/AffiliateListView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "affiliate/AffiliateListView/DESTROY_VIEW";
export const LOAD_RECORDS = "affiliate/AffiliateListView/LOAD_RECORDS";
export const FETCH_RECORDS = "affiliate/AffiliateListView/FETCH_RECORDS";
export const FETCH_RECORDS_START = "affiliate/AffiliateListView/FETCH_RECORDS_START";
export const FETCH_RECORDS_SUCCESS = "affiliate/AffiliateListView/FETCH_RECORDS_SUCCESS";
export const FETCH_RECORDS_FAILURE = "affiliate/AffiliateListView/FETCH_RECORDS_FAILURE";
export const CHANGE_FILTERS = "affiliate/AffiliateListView/CHANGE_FILTERS";
export const CHANGE_PAGINATION = "affiliate/AffiliateListView/CHANGE_PAGINATION";
export const SET_FILTERS = "affiliate/AffiliateListView/SET_FILTERS";
export const SET_PAGINATION = "affiliate/AffiliateListView/SET_PAGINATION";

export const stateSelector = (state) => state.affiliate.AffiliateListView;

const ordersInstance = createResourceInstance({
  LOAD: LOAD_RECORDS,
  FETCH: FETCH_RECORDS,
  FETCH_START: FETCH_RECORDS_START,
  FETCH_SUCCESS: FETCH_RECORDS_SUCCESS,
  FETCH_FAILURE: FETCH_RECORDS_FAILURE,
  stateSelector,
  stateKey: "records",
  getModel: ({ offset, limit, filters }) => {
    return AffiliateRepository.searchOrders({ offset, limit, ...filters });
  },
});

const filtersInstance = createFiltersInstance({
  SET_FILTERS,
  initialFilters: {
    assigned_creator_id: null,
    author_place: null,
    id: null,
    company_id: null,
    created_on: null,
    status: ["building", "waiting_for_customer_approval", "waiting_for_company_approval", "approved", "finished"],
    stock_start_date: null,
    stock_end_date: null,
  },
  filterTypes: {
    assigned_creator_id: "Number",
    author_place: "String[]",
    id: "Number",
    company_id: "Number",
    created_on: "Date",
    status: "String[]",
    stock_start_date: "Date",
    stock_end_date: "Date",
  },
});

const limit = parseInt(localStorage.getItem("affiliateListLimit"), 10) || 10;
const initialState = {
  records: ordersInstance.initialState,
  ...filtersInstance.initialState,
  offset: 0,
  limit: limit,
};

const reducers = {
  ...ordersInstance.reducersMap,
  ...filtersInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),
};

const viewEpics = [
  ...ordersInstance.epics,
  ...filtersInstance.epics,

  (actions$) => actions$.ofType(CHANGE_FILTERS).map(({ filters }) => setFilters(filters)),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) =>
    actions$.ofType(CHANGE_FILTERS).merge(actions$.ofType(CHANGE_PAGINATION)).debounceTime(300).mapTo(fetchRecords()),

  (actions$, { getState }) =>
    actions$
      .ofType(SET_FILTERS)
      .debounceTime(500)
      .map(() => {
        const { filters } = stateSelector(getState());
        const query = filtersInstance._serializeFiltersToLocationQuery(filters);
        return replaceCompanyRoute({ pathname: "/affiliate", query });
      }),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { setFilters, setFiltersWithLocationQuery } = filtersInstance.actions;
export const { load: loadRecords, fetch: fetchRecords } = ordersInstance.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function changeFilters(filters) {
  return { type: CHANGE_FILTERS, filters };
}

export function setParamsWithLocationQuery({ o = initialState.offset, l = initialState.limit, ...query } = {}) {
  return (dispatch) => {
    dispatch(setFiltersWithLocationQuery(query));
    dispatch(setPagination({ offset: +o, limit: +l }));
    dispatch(fetchRecords());
  };
}

export function changeFiltersAndResetOffset(filters) {
  return (dispatch) => {
    dispatch(changePagination({ offset: 0 }));
    dispatch(changeFilters(filters));
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/affiliate/AffiliateListView/index.js